import React from 'react'
import AdOrder from './contexts/AdOrder'
import IsStep from './components/utils/IsStep'
import PageTemplate from './components/layouts/PageTemplate'
import PageContent from './components/layouts/PageContent'
import PageSidebar from './components/layouts/PageSidebar'
import AdInformation from './components/steps/AdInformation'
import ContactInformation from './components/steps/ContactInformation'
import Payment from './components/steps/Payment'
import Confirmation from './components/steps/Confirmation'
import CartSteps from './components/cart/CartSteps'
import CartStep from './components/cart/CartStep'
import Steps from './contexts/Steps'
import Errors from './components/Errors'
import PriceSummary from './components/cart/PriceSummary'
import useSteps from './hooks/useSteps'
import NextStepButton from './components/utils/NextStepButton'

export default function AdForm ({ adRestUrl, adRestImageUrl, steps, cities, payment_cards, field_settings, price_per_week, price_per_week_for_all }) {

  return (
    <AdOrder restUrl={adRestUrl} numberOfCities={cities.length} pricePerWeek={price_per_week}
             pricePerWeekForAll={price_per_week_for_all} fieldSettings={field_settings} paymentCards={payment_cards}>
      <Steps steps={steps}>
        <PageTemplate>
          <PageContent>
            <IsStep step={0}>
              <AdInformation adRestImageUrl={adRestImageUrl} stepInfo={steps[0]} cities={cities}/>
            </IsStep>
            <IsStep step={1}>
              <ContactInformation/>
            </IsStep>
            <IsStep step={2}>
              <Payment/>
            </IsStep>
            <IsStep step={3}>
              <Confirmation/>
            </IsStep>
          </PageContent>
          <PageSidebar>
            <CartSteps>
              <CartStep step={0}/>
              <CartStep step={1}/>
              <CartStep step={2}/>
              <CartStep step={3}/>
            </CartSteps>
            <PriceSummary/>
            <IsStep step={0}>
              <NextStepButton label={'Videre'} style={'white'}/>
            </IsStep>
            <IsStep step={1}>
              <NextStepButton label={'Gå til betaling'} style={'white'}/>
            </IsStep>
            <IsStep step={2}>
              <NextStepButton label={'Bekræft bestilling'} style={'white'}/>
            </IsStep>
            {payment_cards && (
              <img className="payment-icon" src={payment_cards.url} alt={payment_cards.alt ?? null} />
            )}
          </PageSidebar>
        </PageTemplate>
      </Steps>
    </AdOrder>
  )
}
